<template>
  <v-card elevation="0" outlined>
    <v-container fluid class="pa-4">
      <v-row justify="center">
        <!-- Avatar section -->
        <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12" sm="auto" class="text-center">
          <UserAvatarPicker :user="student" type="student" />
        </v-col>

        <!-- Main info section -->
        <v-col>
          <v-row>
            <v-col cols="12">
              <div class="d-flex flex-wrap align-center">
                <div class="mr-4">
                  <div class="text-h5 primary--text">{{ student.name }}</div>
                  <div class="text-subtitle-2">
                    {{ student.code | getStudentCode }}
                    <v-chip small class="white--text ml-2" :color="getColor(student.status)" label>
                      {{ student.status | status }}
                    </v-chip>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="2">
              <v-card flat>
                <div class="text-caption">Ngày sinh</div>
                <div class="text-subtitle-2">{{ student.dob | ddmmyyyy }}</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <v-card flat>
                <div class="text-caption">Bố / Người thân</div>
                <div class="text-subtitle-2">{{ this.student | _get('data.dadName') }}</div>
                <div class="text-subtitle-2">{{ this.student | _get('data.dadPhone') }}</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="8">
              <v-card flat>
                <div class="text-caption">Mẹ / Người thân</div>
                <div class="text-subtitle-2">{{ this.student | _get('data.momName') }}</div>
                <div class="text-subtitle-2">{{ this.student | _get('data.momPhone') }}</div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <!-- Action buttons -->
        <v-col
          cols="12"
          md="auto"
          class="d-flex"
          :class="{ 'justify-end': $vuetify.breakpoint.mdAndUp, 'flex-column': $vuetify.breakpoint.mdAndUp }"
          align-self-end
        >
          <v-btn @click="detailState = !detailState" small color="primary" outlined> Hồ sơ chi tiết </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <StudentProfileDetailDialog @edit="editState = !editState" :student="student" :state="detailState" />
    <EditStudentDialog :student="student" :state="editState" />
  </v-card>
</template>

<script>
import UserAvatarPicker from '@/components/basic/picker/UserAvatarPicker'
import StudentProfileDetailDialog from './StudentProfileDetailDialog'
import EditStudentDialog from './EditStudentDialog'

export default {
  components: {
    StudentProfileDetailDialog,
    EditStudentDialog,
    UserAvatarPicker,
  },
  data() {
    return {
      detailState: false,
      editState: false,
    }
  },

  props: {
    student: Object,
  },

  methods: {
    getColor(status) {
      switch (status) {
        case 'active':
          return '#46BE8A'
        case 'unassignedClass':
          return 'blue-grey'
        case 'reserved':
          return 'orange'
        case 'graduated':
          return 'primary'
        case 'left':
          return 'red'
        default:
          return 'grey'
      }
    },
  },
}
</script>

<style scoped>
.v-card.flat {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
